import queryString from "query-string";
import { PureComponent } from "react";

import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";
import { asyncState, validNumber } from "@/utils/calculators";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

type YtongCalculatorState = {
    wallLength: number;
    wallHeight: number;
    wallArea: number;
    brickWidth: number;
    brickLength: number;
    brickHeight: number;
    brickArea: number;
};

class YtongCalculator extends PureComponent<{}, YtongCalculatorState> {
    query = queryString.parse(location.search);

    constructor(props: {}) {
        super(props);

        this.state = {
            wallLength: this.query.wallLength
                ? Number(this.query.wallLength)
                : 0,
            wallHeight: this.query.wallHeight
                ? Number(this.query.wallHeight)
                : 0,
            brickWidth: this.query.brickWidth
                ? Number(this.query.brickWidth)
                : 0,
            brickLength: this.query.brickLength
                ? Number(this.query.brickLength)
                : 0,
            brickHeight: this.query.brickHeight
                ? Number(this.query.brickHeight)
                : 0,
            wallArea: 0,
            brickArea: 0
        };
    }

    async componentDidMount() {
        await asyncState(this, {
            wallArea: this.wallArea(),
            brickArea: this.brickArea()
        });

        CalculatorStepTracker.trackStart(CALCULATOR_KEYS.ytong);
    }

    // calculations
    wallArea = () => {
        let wallArea = 0;

        const wallLength = this.state.wallLength;

        const wallHeight = this.state.wallHeight;

        if (validNumber(wallLength) && validNumber(wallHeight)) {
            wallArea = wallLength * wallHeight;
        }

        return Number(wallArea);
    };
    brickArea = () => {
        let brickArea = 0;

        const brickLength = this.state.brickLength;

        const brickHeight = this.state.brickHeight;

        if (validNumber(brickLength) && validNumber(brickHeight)) {
            brickArea = (brickLength + 0.3) * (brickHeight + 0.3) * 0.0001;
        }

        return brickArea;
    };

    // setters
    setBrickMeasurements = (length: number, width: number, height: number) =>
        this.setState(
            {
                brickLength: length,
                brickWidth: width,
                brickHeight: height
            },
            () => this.calculateFields()
        );

    setCalculationValue = (field: string, value: string) => {
        const numberValue = parseFloat(value.replace(",", "."));
        this.setState(
            (state) => ({ ...state, [field]: numberValue }),
            () => this.calculateFields()
        );
    };

    calculateFields = () =>
        this.setState(
            {
                wallArea: this.wallArea(),
                brickArea: this.brickArea()
            },
            () => {
                CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.ytong);
            }
        );

    render() {
        const calculationProps = {
            setCalculationValue: this.setCalculationValue,
            setBrickMeasurements: this.setBrickMeasurements,
            wallLength: this.state.wallLength,
            wallHeight: this.state.wallHeight,
            brickLength: this.state.brickLength,
            brickWidth: this.state.brickWidth,
            brickHeight: this.state.brickHeight
        };
        const resultProps = {
            wallArea: this.state.wallArea,
            brickArea: this.state.brickArea,
            brickWidth: this.state.brickWidth,
            mailParams: {
                wallLength: this.state.wallLength,
                wallHeight: this.state.wallHeight,
                brickLength: this.state.brickLength,
                brickWidth: this.state.brickWidth,
                brickHeight: this.state.brickHeight
            }
        };

        return (
            <div id="calculator">
                <Calculation {...calculationProps} />
                <Result {...resultProps} />
            </div>
        );
    }
}

export { YtongCalculator };
